/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArcheryArrow = createReactComponent("archery-arrow", "IconArcheryArrow", [
  ["path", { d: "M14 7v3h3l3 -3h-3v-3z", key: "svg-0" }],
  ["path", { d: "M14 10l-9 9", key: "svg-1" }],
  ["path", { d: "M5 15v4h4", key: "svg-2" }]
]);

export { IconArcheryArrow as default };
//# sourceMappingURL=IconArcheryArrow.js.map
